import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";

const setupAxios = () => {
  // API base URL is read from REACT_APP_API_URL at build time (set it in .env
  // before running `npm run build`). Falls back to the old domain if unset.
  axios.defaults.baseURL =
    process.env.REACT_APP_API_URL || "https://api.jatinmorjewels.com";

  axios.defaults.headers = {
    "Cache-Control": "no-cache,no-store",
    Pragma: "no-cache",
    Expires: "0",
  };
};

setupAxios();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
